module.exports = __webpack_public_path__ + "img/italy-stomach-cancer-male.c7d72026.png";